import React, { useState, useEffect } from "react";
import parse from 'html-react-parser';

function Instructions() {
  const [data, setData] = useState("<div></div>");

  useEffect(() => {
    function fetchPageData() {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/temp/statictext/3")
      .then(res => res.json())
      .then(result => setData(result.text))
      .catch(console.log);
    }
    fetchPageData();
  }, []);

  return (
    <div className="home">
      <div class="info-page-container">
          <h1>Instructions</h1>
        <div class="info-page-content">
            {parse(data)}
        </div>
      </div>
    </div>
  );
}

export default Instructions;